import React, { Component, Fragment } from "react";
import * as PropTypes from "prop-types";

import { Row, Col, Button, Modal, message, Tooltip } from "antd";

import moment from "moment";

import { timeCardService } from "./../../../redux/services";

import ModalAjustes from "../ModalAjustes";
import ModalActions from "../ModalActions";
import ModalDetails from "../ModalDetails";
import { icones_status } from "../../../enum/status";

class TableRow extends Component {
	static propTypes = {
		columns: PropTypes.arrayOf(
			PropTypes.shape({
				title    : PropTypes.string,
				className: PropTypes.string,
				width    : PropTypes.any,
				visible  : PropTypes.bool,
				render   : PropTypes.func.isRequired,
			}),
		),
		item: PropTypes.object,
		index: PropTypes.number,
		hover: false,
	}

	constructor(props) {
		super(props);

		this.state = {
			ajustesModalVisible: false,
			actionsModalVisible: false,
			detailsModalVisible: false,
		};
	}

	actionsOpen = () => {
		this.setState({ actionsModalVisible: true });

		// On open screen
		this.actionsScreen.onOpen();
	};

	actionsOnClose = () => {
		this.setState({ actionsModalVisible: false });
	}

	actionsOnComplete = (item) => {
		this.setState({ actionsModalVisible: false });
		this.props.updateRow(item);
	}

	detailsOpen = () => {
		this.setState({ detailsModalVisible: true });

		// On open screen
		this.detailsScreen.onOpen();
	};

	detailsOnClose = () => {
		this.setState({ detailsModalVisible: false });
	}

	detailsOnComplete = (reloadRow) => {
		this.setState({ detailsModalVisible: false });
		if (reloadRow) this.props.reloadRow(reloadRow);
	}

	ajustesOpen = () => {
		this.setState({ ajustesModalVisible: true });

		// On open screen
		this.ajustesScreen.onOpen();
	};

	ajustesOnClose = () => {
		this.setState({ ajustesModalVisible: false });
	}

	ajustesOnComplete = () => {
		this.setState({ ajustesModalVisible: false });
	}

	restartOpen = (manter_jornada_original = false) => {
		if (this.props.item?.status !== 'execao') {
			return this.confirmRestart(manter_jornada_original);
		}
		Modal.confirm({
			title: `Deseja manter as exceções caso houver?`,
			content: "Esta ação não poderá ser desfeita.",
			okText: "Sim",
			cancelText: "Não",
			centered: true,
			onCancel: () => {
				this.confirmRestart(manter_jornada_original, true);
			},
			onOk: () => {
				this.confirmRestart(manter_jornada_original, false);
			},
		});		
	};

	confirmRestart = (manter_jornada_original, deletar_execao) => {
		Modal.confirm({
			title: `Deseja voltar os dados originais para esse dia [${moment(this.props.dataDia).format("DD/MM/YYYY")}]?`,
			content: "Esta ação não poderá ser desfeita.",
			okText: "Sim",
			cancelText: "Não",
			centered: true,
			onCancel: () => {
				document.querySelector(".ant-modal-wrap").focus();
			},
			onOk: () => {
				return this.restartOnComplete(manter_jornada_original, deletar_execao);
			},
		});
	}

	restartOnComplete = (
		manter_jornada_original = false, 
		deletar_execao = null,
	) => {
		return timeCardService
			.restart({
				cartao_ponto_id: this.props.item.id,
				manter_jornada_original,
				deletar_execao,
			})
			.then((response) => {
				// this.props.fetchGetAll(true);
				const base = moment(this.props.dataDia);
				const initial = base.clone().subtract(1, 'day').format('YYYY-MM-DD');
				const final = base.clone().add(1, 'day').format('YYYY-MM-DD');

				//TODO buscar apenas de um periodo estava gerando desencontro nos totais.
				// this.props.fetchGetItems(true, initial, final, false, 1);
				this.props.fetchGetAll(true);
				this.actionsOnClose();
				
				// Success message
				message.success('Os dados originais voltaram com sucesso.');
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}

	reindexarBatidasOpen = () => {
		Modal.confirm({
			title: `Deseja reindexar as batidas para o dia [${moment(this.props.dataDia).format("DD/MM/YYYY")}]?`,
			content: "As batidas serão reordenadas cronologicamente.",
			okText: "Sim",
			cancelText: "Não",
			centered: true,
			onCancel: () => {
				document.querySelector(".ant-modal-wrap").focus();
			},
			onOk: () => {
				return this.reindexarBatidasOnComplete();
			},
		});
	};

	reindexarBatidasOnComplete = () => {
		return timeCardService
			.reindexarBatidas({
				cartao_ponto_id: this.props.item.id,
			})
			.then((response) => {
				this.props.fetchGetAll(true);
				this.actionsOnClose();
				message.success('Batidas reindexadas com sucesso.');
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}

	limparCartaoPontoOpen = () => {
		Modal.confirm({
			title: `Deseja limpar o cartão ponto do dia [${moment(this.props.dataDia).format("DD/MM/YYYY")}]?`,
			content: "Todos os ajustes serão removidos e as batidas ficarão em branco. Utilize 'Retornar dados originais' ou 'Reindexar batidas' para repopular.",
			okText: "Sim",
			cancelText: "Não",
			centered: true,
			onCancel: () => {
				document.querySelector(".ant-modal-wrap").focus();
			},
			onOk: () => {
				return timeCardService
					.limparCartaoPonto({ cartao_ponto_id: this.props.item.id })
					.then(() => {
						this.props.fetchGetAll(true);
						this.actionsOnClose();
						message.success('Cartão ponto limpo com sucesso.');
					})
					.catch((data) => {
						Modal.error({
							title: "Ocorreu um erro!",
							content: String(data),
						});
					});
			},
		});
	};

	recalcularDiaOpen = () => {
		Modal.confirm({
			title: `Recalcular o dia [${moment(this.props.dataDia).format("DD/MM/YYYY")}]`,
			content: "Deseja reindexar as batidas junto com o recálculo?",
			okText: "Com reindex",
			cancelText: "Sem reindex",
			centered: true,
			onOk: () => {
				return this.recalcularDiaExecutar(true);
			},
			onCancel: () => {
				return this.recalcularDiaExecutar(false);
			},
		});
	};

	recalcularDiaExecutar = (reindexar_batidas) => {
		return timeCardService
			.recalcularDia({
				cartao_ponto_id: this.props.item.id,
				reindexar_batidas,
			})
			.then(() => {
				this.props.fetchGetAll(true);
				this.actionsOnClose();
				message.success(`Recalculado com sucesso${reindexar_batidas ? ' (com reindex)' : ''}.`);
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	getBackgroundColorForStatus(status, rowIndex) {
		switch (status) {
			case 'folga':
				return '#94EDF9';
			case 'feriado':
				return '#8DB1FA';
			case 'dia_especial':
				return '#FA97CB';
			case 'afastamento':
				return '#FED58B';
			case 'execao':
				return '#59f2e4';
			case 'justificativa_parcial':
				return 'rgb(81,0,202, 0.35)';
			case 'dia_todo':
				return 'rgb(250, 200, 255, 0.35)';
			default:
				return '#FFFFFF';
				// return rowIndex % 2 === 0 ? '#00c9ff24' : '#FFFFFF';
		}
	}

	setHover(hover) {
		this.setState({ hover });
	}

	render() {
		const { columns, item, index } = this.props;
		const necessitaReindex = item?.necessita_reindex;
		return (
			<Tooltip title={necessitaReindex ? "Batidas fora de ordem cronológica. Utilize 'Reindexar batidas' nas ações." : ''} placement="left">
			<div className="list-items-item" style={necessitaReindex ? { border: '2px solid #fa8c16', borderRadius: 4 } : {}}>
				<div className="row">
					{columns.map((column, col_index) => {
						const isLastColumn = col_index === columns.length - 1;
						const isFromInactiveContract = item?.contrato?.arquivar === 1;

						let columnProps = {
							key: index,
							className: `col ${column.className || ""} ${isLastColumn ? 'last-column-timeCard' : ''}`,
							style: {},
						};
		
						if (column.width) {
							columnProps.style.width = column.width;
							columnProps.style.minWidth = column.width;
							columnProps.style.maxWidth = column.width;
						}

						if(column.className === "actions") {
							return (
								<div 
									data-title={column.title} 
									{...columnProps}
									style={{ 
										backgroundColor: this.getBackgroundColorForStatus(item.status, index), 
										...columnProps.style 
									}}
								>
									<Row 
										justify="center" 
										className="covl status"
										onMouseEnter={() => this.setHover(true)}
										onMouseLeave={() => this.setHover(false)}
										style={{ 
											backgroundColor: this.state.hover ? item?.status_cor || '#000' : 'transparent',
										}}
									>
										<Tooltip placement="top" title={column?.getStatusTitle(item)} trigger="hover">											
											<div 
												className={`fas ${icones_status[item?.status]?.icon}`} 
												style={{
													fontSize: '20px',
													color: this.state.hover ? icones_status[item?.status]?.color : item?.status_cor || '#000',
												}}
											/>
										</Tooltip>
										<Tooltip title={isFromInactiveContract ? 'Dia referente a contrato arquivado e não poderá ser editado!' : ''}>
											<Button 
												disabled={isFromInactiveContract} 
												type="link"
												style={{ 
													color: this.state.hover ? icones_status[item?.status]?.color : '#777',
													width: '16px',
												}}
												icon={<i className="fas fa-chevron-down" style={{ fontSize: '10px', width: '16px' }}></i>} 
												onClick={this.actionsOpen} 
											/>
										</Tooltip>
									</Row>
								</div>
							)
						} else {
							return (
								<div 
									data-title={column.title} 
									{...columnProps} 
									style={{ 
										backgroundColor: col_index > 3 ? '#fff':  column.title === 'Dia' && column.hasJustificationRequest(item) ? '#E9B949' : this.getBackgroundColorForStatus(item.status, index),
										...columnProps.style 
									}}
								>
									<Fragment>{column.render(item, index)}</Fragment>
								</div>
							)
						}
					})}
				</div>
				<ModalDetails
					ref={el => this.detailsScreen = el}
					visible={this.state.detailsModalVisible}
					onComplete={this.detailsOnComplete}
					onClose={this.detailsOnClose}
					empresa={item?.contrato?.empresa?.nome}
					departamento={item?.departamento?.nome}
					funcionario={item?.funcionario?.nome}
					dataDia={this.props.dataDia}
					cartaoPontoId={item?.id}
					contrato={item?.contrato}
					funcionario_id={item?.funcionario?.id}
				/>
				<ModalActions
					ref={el => this.actionsScreen = el}
					visible={this.state.actionsModalVisible}
					onComplete={this.actionsOnComplete}
					onClose={this.actionsOnClose}
					restartOpen={this.restartOpen}
					reindexarBatidasOpen={this.reindexarBatidasOpen}
					limparCartaoPontoOpen={this.limparCartaoPontoOpen}
					recalcularDiaOpen={this.recalcularDiaOpen}
					detailsOpen={this.detailsOpen}
					newJoinColumn={() => { this.props.newJoinColumn(), this.actionsOnClose() }}
					removeBatida={() => { this.props.removeBatida(), this.actionsOnClose() }}
					journeyOpen={this.props.journeyOpen}
					dataDia={this.props.dataDia}
					empresa={item?.contrato?.empresa}
					departamento={item?.departamento}
					funcionario={item?.funcionario}
					cartaoPontoId={item?.id}
					tipoCalculo={item?.tipo_calculo}
					item={item}
					dataInicial={this.props.dataInicial}
					dataFinal={this.props.dataFinal}
					reloadRow={this.props.reloadRow}
				/>
				<ModalAjustes
					ref={el => this.ajustesScreen = el}
					visible={this.state.ajustesModalVisible}
					onComplete={this.ajustesOnComplete}
					onClose={this.ajustesOnClose}
					dataDia={this.props.dataDia}
					funcionarioId={item?.funcionario?.id}
				/>
			</div>
			</Tooltip>
		)
	}
}

export default TableRow;
